'use client';

import React from 'react';
import NextLink from 'next/link';
import ChannelList from '../navigation/ChannelList';
import { ScrollArea } from '@/components/ui/scroll-area';
import { Separator } from '@/components/ui/separator';
import { Settings, ChevronRight } from 'lucide-react';
import { useDashboard } from '../DashboardContext';

const ChannelSidebar = () => {
  const { currentGuildId, currentGuild, closeSidebar, currentChannelId, isDesktop } = useDashboard();
  const [settingsOpen, setSettingsOpen] = React.useState(false);

  // 설정 메뉴 토글
  const handleSettingsClick = () => {
    setSettingsOpen(!settingsOpen);
  };

  // 서버 설정 메뉴 아이템
  const settingsMenuItems = [
    { name: '환영 메시지', path: `/dashboard/${currentGuildId}/settings/welcome-message` },
    { name: 'TTS 설정', path: `/dashboard/${currentGuildId}/settings/tts` },
    { name: '채널 기본값', path: `/dashboard/${currentGuildId}/settings/channel-default` },
  ];

  return (
    <div className="w-[240px] flex-shrink-0 flex flex-col border-r border-border h-full">
      {/* 서버 헤더 */}
      <div className="border-b border-border">
        <NextLink
          href={`/dashboard/${currentGuildId}`}
          onClick={closeSidebar}
          className="flex items-center justify-between p-4 w-full hover:bg-[var(--hover-item)] hover:text-[var(--selected-item-text)]"
        >
          <div className="flex items-center gap-3 flex-1">
            <Settings className="h-4 w-4 text-foreground dark:text-foreground" />
            <h3 className="text-base font-semibold text-foreground truncate">
              {currentGuild?.name || '서버 선택됨'}
            </h3>
          </div>
          <ChevronRight className="h-4 w-4 flex-shrink-0" />
        </NextLink>
      </div>

      {/* 스크롤 영역 */}
      <ScrollArea className="flex-1 h-[calc(100%-57px)]">
        <div className="p-2">
          {/* 서버 설정 섹션 */}
          {/* 드롭다운 메뉴 포함 */}
          {/* 
          <Collapsible
            open={settingsOpen}
            onOpenChange={setSettingsOpen}
            className="w-full"
          >
            <CollapsibleTrigger className="flex items-center w-full p-2 rounded-md hover:!bg-[var(--hover-item)] hover:!text-[var(--selected-item-text)]">
              <div className="flex items-center gap-3 flex-1">
                <Settings className="h-4 w-4 text-foreground dark:text-foreground" />
                <span className="text-sm text-foreground dark:text-foreground">서버 설정</span>
              </div>
              {settingsOpen ? (
                <ChevronDown className="h-4 w-4 text-foreground dark:text-foreground" />
              ) : (
                <ChevronRight className="h-4 w-4 text-foreground dark:text-foreground" />
              )}
            </CollapsibleTrigger> 
            <CollapsibleContent>
              <div className="pl-9 pb-2 space-y-1">
                {settingsMenuItems.map((item) => (
                  <a
                    key={item.name}
                    href={item.path}
                    className="block py-1.5 text-sm text-muted-foreground hover:text-foreground dark:text-muted-foreground dark:hover:text-foreground"
                  >
                    {item.name}
                  </a>
                ))}
              </div>
            </CollapsibleContent>
          </Collapsible>
          */}

          {/* 드롭다운 메뉴 미포함 */}
          {
            (currentChannelId || !isDesktop) &&
            <>
              <NextLink className="flex items-center w-full p-2 rounded-md hover:!bg-[var(--hover-item)] hover:!text-[var(--selected-item-text)]"
                href={`/dashboard/${currentGuildId}`}
                onClick={closeSidebar}
              >
                <div className="flex items-center gap-3 flex-1">
                  <Settings className="h-4 w-4 text-foreground dark:text-foreground" />
                  <span className="text-sm text-foreground dark:text-foreground">서버 전체 설정</span>
                </div>
                <ChevronRight className="h-4 w-4 text-foreground dark:text-foreground" />
              </NextLink>
              <Separator className="my-2" />
            </>
          }

          {/* 채널 목록 */}
          <div className="mt-1">
            <ChannelList />
          </div>
        </div>
      </ScrollArea>
    </div>
  );
};

export default ChannelSidebar;
